import { ErrorKey } from "@/store/baseClientApi";
import { Beacon } from "@/utils/beacon";

export const OpenEventLogErrorLearnMoreDocs: {
  [id in ErrorKey]: () => void;
} = {
  model_basing_basing_error: () => Beacon("ask-question", "Explain Basing Errors"),
  model_basing_hollowing_error: () => Beacon("ask-question", "Explain Hollowing Errors"),
  model_basing_occlusal_plane_error: () => Beacon("ask-question", "Explain Occlusal Plane Errors"),
  model_basing_pillar_generation_error: () => Beacon("ask-question", "Explain Pillar Generation Errors"),
  model_basing_preprocessing_error: () => Beacon("ask-question", "Explain Preprocessing Errors"),
  model_basing_text_generation_error: () => Beacon("ask-question", "Explain Text Generation Errors"),
  model_basing_text_generation_warning: () => Beacon("ask-question", "Explain Text Generation Warnings"),
  model_basing_tooth_segmentation_error: () => Beacon("ask-question", "Explain Tooth Segmentation Errors"),
  model_basing_vent_generation_error: () => Beacon("ask-question", "Explain Vent Generation Errors"),
  timeout_error: () => Beacon("article", "68b0bf8af5f1da300ae1e1ec")
};
